/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Private modules
 */
import { scale } from '../.private';

/**
 * Private functions
 */
const getStyles = (props) => {
  const { mode } = props;
  const styles = [];
  switch (mode) {
    case 'downline': {
      styles.push('background-color: rgba(46, 204, 113, 0.2);');
      styles.push(`
        text-align: right;
        a {
          justify-content: flex-end;
        }
      `);
      break;
    }
    case 'self': {
      styles.push('background-color: rgba(241, 196, 15, 0.2);');
      styles.push(`
        text-align: right;
        a {
          justify-content: flex-end;
        }
      `);
      break;
    }
    case 'expected': {
      styles.push('background-color: rgba(155, 89, 182, 0.2);');
      styles.push(`
        text-align: right;
        a {
          justify-content: flex-end;
        }
      `);
      break;
    }
    case 'upline': {
      styles.push('background-color: rgba(155, 89, 182, 0.2);');
      styles.push(`
        text-align: right;
        a {
          justify-content: flex-end;
        }
      `);
      break;
    }
    case 'whole': {
      styles.push('background-color: rgba(52, 152, 219, 0.2);');
      styles.push(`
        text-align: right;
        a {
          justify-content: flex-end;
        }
      `);
      break;
    }
    case 'nowrap': {
      styles.push('white-space: nowrap;');
      styles.push(`
        text-align: center;
        a {
          justify-content: center;
        }
      `);
      break;
    }
    case 'heading': {
      styles.push(`
        text-align: center;
        a {
          justify-content: center;
        }
      `);
      break;
    }
    default: {
      styles.push(`
        text-align: right;
        a {
          justify-content: flex-end;
        }
      `);
      break;
    }
  }
  return styles.join('');
};
export default styled.td`
  /* stylelint-disable */
  ${getStyles};
  /* stylelint-enable */
  > div {
    .ant-tag {
      margin-left: 8px;
    }
  }
  border: ${scale.minor(0.25)}px solid rgba(189, 195, 199, 0.5);
  padding: ${scale.minor(1)}px;
`;
